module.exports = __webpack_public_path__ + "img/symbol_3.fd224040.png";